import React from "react";
import { FormControl, Select, MenuItem } from "@mui/material";
import { TemplateSelectInputProps, NOTE_TEMPLATES } from "./PatientNotesConstants";

// Select implementation - I suspect this won't be used (unless we have a lot of templates...), but leaving it here for now
export const PatientNotesTemplateInputSelect: React.FC<TemplateSelectInputProps> = React.memo((p) => {
  const { value, onChange, onTemplateSelect, error, disabled } = p;

  return (
    <FormControl size="small" sx={{ minWidth: 180 }}>
      <Select
        value={value}
        onChange={(e) => {
          const selectedValue = e.target.value as string;
          onChange(selectedValue);
          if (selectedValue) {
            const selectedTemplate = NOTE_TEMPLATES.find((t) => t.id === selectedValue);
            onTemplateSelect(selectedTemplate || null);
          } else {
            onTemplateSelect(null);
          }
        }}
        disabled={disabled}
        error={Boolean(error)}
        variant="standard"
        displayEmpty
        renderValue={(selected) => {
          if (!selected) {
            return <span style={{ color: "rgba(0, 0, 0, 0.6)" }}>Apply template...</span>;
          }
          const template = NOTE_TEMPLATES.find((t) => t.id === selected);
          return template ? template.title : (selected as string);
        }}
        sx={{
          "& .MuiSelect-select": {
            paddingTop: 0,
            paddingBottom: 0,
          },
          "& .MuiInput-underline:before": {
            borderBottomColor: "rgba(0, 0, 0, 0.12)",
          },
          "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderBottomColor: "rgba(0, 0, 0, 0.3)",
          },
        }}
      >
        <MenuItem value="">None</MenuItem>
        {NOTE_TEMPLATES.map((template) => (
          <MenuItem key={template.id} value={template.id}>
            {template.title}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
});

PatientNotesTemplateInputSelect.displayName = "PatientNotesTemplateInputSelect";
